module.exports = __webpack_public_path__ + "img/logo-full.ec6ac607.svg";